const bodyScroll = {
  init() {
    this._isLockedByMyself = false;
  },
  lock() {
    this._checkCurrentLockState();
    document.body.style.overflow = 'hidden';
  },
  unlock() {
    if (!this._isLockedByMyself) return;
    document.body.style.overflow = null;
  },
  _checkCurrentLockState() {
    this._isLockedByMyself = document.body.style.overflow !== 'hidden';
  }
};

bodyScroll.init();

export { bodyScroll };
